import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import DoneIcon from "@mui/icons-material/Done";
import {
  Box,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import GlobalButton from "../../../components/CustomButton";
import appcolors from "../../../constants/Colors";
import { CURRENCY } from "../../../constants/Variables";
import { useTranslation } from "react-i18next";

const style = {
  cardContainer: {
    border: "2px solid #E7E9ED",
    padding: 2,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    height: "100%",
  },
  dollarIcon: {
    fontWeight: 600,
    fontSize: "0.8rem",
    color: appcolors.black,
    fontFamily: "GiloryBold",
  },
  price: {
    fontWeight: 600,
    fontSize: "2.5rem",
    color: appcolors.black,
    fontFamily: "GiloryBold",
  },
  duration: {
    fontWeight: 300,
    fontSize: "0.8rem",
    color: appcolors.black,
    marginLeft: 4,
  },
};

function PlansCard({ val, index, handleUpdatePrice, language }) {
  const { t } = useTranslation(["common"]);
  return (
    <Grid key={val._id} item xs={12} sm={6} md={4}>
      <Box sx={style.cardContainer}>
        <Box>
          <Typography
            variant="h3"
            color={"#473BF0"}
            fontSize={"0.875rem"}
            textTransform={"uppercase"}
          >
            {val.name[language]}
          </Typography>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "20px",
              flexWrap: "wrap",
            }}
          >
            <Box>
              <Typography mt={2} variant="h2" style={style.price}>
                <span style={style.dollarIcon}>{CURRENCY}</span>
                {val.price}
                <span style={style.duration}>/{t(val.duration)}</span>
              </Typography>
              <Typography variant="body1" fontFamily={"GiloryLight"}>
                {t("billed")} {t(val.duration)}
              </Typography>
            </Box>
            <Box>
              <Typography mt={2} variant="h2" style={style.price}>
                <span style={style.dollarIcon}>{CURRENCY}</span>
                {val.yearlyPrice ? val.yearlyPrice : 0}
                <span style={style.duration}>/{t("yearly")}</span>
              </Typography>
              <Typography variant="body1" fontFamily={"GiloryLight"}>
                {t("billed")} {t("yearly")}
              </Typography>
            </Box>
          </Box>
          <List sx={{ m: "20px 0" }}>
            {val.features.map((item, ind) => {
              return (
                <ListItem key={ind} sx={{ padding: "2px 0px" }}>
                  <ListItemIcon sx={{ minWidth: 25 }}>
                    <DoneIcon htmlColor="#68D585" sx={{ fontSize: "1.3rem" }} />
                  </ListItemIcon>
                  <ListItemText
                    sx={{
                      "& .MuiListItemText-secondary": {
                        color: "#161C2D",
                      },
                    }}
                    secondary={item.title[language]}
                  />
                </ListItem>
              );
            })}
          </List>
        </Box>
        <Box height={50}>
          <GlobalButton
            variant={"contained"}
            btnText={"update"}
            styleProps={{ fontWeight: 400 }}
            endIcon={<ArrowForwardIcon htmlColor={appcolors.white} />}
            handleClickBtn={() => handleUpdatePrice(val)}
          />
        </Box>
      </Box>
    </Grid>
  );
}

export default PlansCard;
